export default __webpack_public_path__ + "static/media/search-check.c52348f6.svg";